import React, { useState } from "react";
import { getUrl } from "@outplayed/riot-assets";
import { directToPage } from "lib/redirect-helpers";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { useLoginState, useUserPremiumState } from "lib/hooks/userHooks";
import { useMutation } from "@apollo/client";
import { Link, useHistory } from "react-router-dom";
import QUEUE_SUMMONER_REVIEW from "components/Pages/PerformanceReview/queries/generateReview";

const PerformanceAnalysisLandingHeader = (props) => {
  const [errorOnGenerate, setErrorOnGenerate] = useState();
  const [linkToSummoner, setLinkToSummoner] = useState(null);
  const isLoggedIn = useLoginState();
  const history = useHistory();

  let { summonerName, isVerified, isPremium, regionId } = props;
  const directToHome = directToPage("home");
  const directToLogin = directToPage("login");
  const directToVerification = directToPage("verification", { searchParams: [["continue", "yir"]] });
  const directToPremium = directToPage("boost");
  const directToLoadingPage = directToPage("loadingYIR", {
    searchParams: [["duration", "60"]],
  });

  const [queueReview] = useMutation(QUEUE_SUMMONER_REVIEW);

  const generateReview = (_, res) => {
    const onCompleteFetch = (_client, res) => {
      const { data } = res;
      const { enqueueSummonerReview } = data;
      if (enqueueSummonerReview.success) {
        directToLoadingPage();
      } else {
        // TODO fix this so summonerName and region ID are always returned
        setLinkToSummoner({
          summonerName: enqueueSummonerReview.summonerName,
          regionId: enqueueSummonerReview.regionId,
        });
      }
    };

    const onError = () => {
      setErrorOnGenerate(true);
    };

    queueReview({
      variables: {
        summonerName: summonerName,
        regionId: regionId,
        season: 14,
      },
      update: onCompleteFetch,
      onError,
    });
  };

  const pathToPlan = (plan) => {
    if (isLoggedIn && isPremium) {
      return `/settings/boost/change-plan?plan-chosen=${plan}`;
    } else if (isLoggedIn && !isPremium) {
      return `/boost/payment?planType=${plan}`;
    } else {
      return `/signup?continue=/purchase/${plan}&type=premium_boost`;
    }
  };

  if (isVerified && isPremium) {
    return (
      <div className="verification-header">
        <img className="ugg-logo" src={getUrl("ugg/logo/ugg-logo.svg")} onClick={directToHome} />
        <div>
          <img className="yir-logo" src={getUrl("lol/performance_analysis/images/L20_gold.svg")} />
        </div>
        <div className="bold-text">{summonerName}</div>
        <div className="basic-text">Your account is verified and ready to go</div>
        <ButtonSuccess
          className="login-submit btn-light-blue generate-button"
          label="Generate 2020 Review"
          onClick={generateReview}
          bForceSubmitOnEnter={true}
        />
        {linkToSummoner && (
          <div className="duplicate-report">
            A report has already been generated by this U.GG account.&nbsp;
            <Link
              className="duplicate-report-link"
              to={`reports/14/year-in-review?region=${linkToSummoner.regionId}&summonerName=${linkToSummoner.summonerName}`}
            >
              Click Here
            </Link>
          </div>
        )}

        {errorOnGenerate && (
          <div className="error-generating-report">
            Error generating report<a href="mailto:info@u.gg">Please Contact Us</a>
          </div>
        )}
        <div className="basic-text">Want to get your Year in Review for a different LoL account?</div>
        <ButtonSuccess
          className="login-submit btn-light-blue verify-button"
          label="Verify New Account"
          onClick={directToVerification}
          bForceSubmitOnEnter={true}
        />
        <div className="see-more_sticky">
          <div className="bold-text large see-more">SEE MORE</div>
          <img src={getUrl("lol/performance_analysis/icons/long_down_arrow.svg")} />
        </div>
      </div>
    );
  } else if (isPremium && !isVerified) {
    return (
      <div className="verification-header">
        <img className="ugg-logo" src={getUrl("ugg/logo/ugg-logo.svg")} onClick={directToHome} />
        <div>
          <img className="yir-logo" src={getUrl("lol/performance_analysis/images/L20_gold.svg")} />
        </div>
        <div className="barlow-header">VERIFY YOUR LEAGUE OF LEGENDS ACCOUNT TO GET YOUR YEAR END REVIEW</div>
        <ButtonSuccess
          className="login-submit btn-light-blue generate-button"
          label="Verify Now"
          onClick={directToVerification}
          bForceSubmitOnEnter={true}
        />
        <div className="see-more_sticky">
          <div className="bold-text large see-more see-more-extra-margin">SEE MORE</div>
          <img src={getUrl("lol/performance_analysis/icons/long_down_arrow.svg")} />
        </div>
      </div>
    );
  } else {
    return (
      <div className="verification-header">
        <img className="ugg-logo" src={getUrl("ugg/logo/ugg-logo.svg")} onClick={directToHome} />
        <div>
          <img className="yir-logo" src={getUrl("lol/performance_analysis/images/L20_gold.svg")} />
        </div>
        <div className="barlow-header">SIGN UP FOR U.GG BOOST TO ACCESS YOUR 2020 YEAR IN REVIEW.</div>
        <ButtonSuccess
          className="login-submit btn-light-blue generate-button"
          label="Start Today for $1"
          onClick={() => {
            history.push(pathToPlan("1-months"));
          }}
          bForceSubmitOnEnter={true}
        />
        <div className="basic-text">
          Have BOOST?{" "}
          <span className="login-link" onClick={directToLogin}>
            Login
          </span>
        </div>
        <div className="see-more_sticky">
          <div className="bold-text large see-more see-more-extra-margin">SEE MORE</div>
          <img src={getUrl("lol/performance_analysis/icons/long_down_arrow.svg")} />
        </div>
      </div>
    );
  }
};

export default PerformanceAnalysisLandingHeader;
